import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdWastageRow = (props) => {
    const { formObject, rowKey } = props;


    return (
        <ul className="uiDPEditLine uiTableRowLevel1">
            <li className="uiColumnLeft uiColumn130">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnLeft uiColumn350">
                <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                    action={{ paramName: "actualItem", actionId: "show" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyIssued1" param2="qtyIssued2" format="a" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyWasted1" param2="qtyWasted2" format="a" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyDamaged1" param2="qtyDamaged2" format="a" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyLost1" param2="qtyLost2" format="a" />
            <li className="uiColumnRight uiColumnQty">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percAllowance" }} />
            </li>
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyAllowanced1" param2="qtyAllowanced2" format="a" />
            <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyDiff1" param2="qtyDiff2" format="a" />
            <li className="uiColumnRight uiColumnQty">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percLoss" }} />
            </li>
            <li className="uiColumnRight uiColumnQty">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "percDiff" }} />
            </li>
            <li className="uiColumnRight uiColumn70">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "wastageValue" }} />
            </li>
            <li className="uiColumnRight uiColumn70">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "deduction" }} />
            </li>
            <li className="uiColumnLeft uiColumn150">
                <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
            </li>
        </ul>
    )
}

export default ProdWastageRow
